"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FileTypeEML = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FileTypeEML_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14h-.17A3.001 3.001 0 0 1 12 16H4a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5.517a2 2 0 0 1 1.4.571L14.4 3.983a2 2 0 0 1 .6 1.429V9a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1ZM2 13V3a2 2 0 0 1 2-2h5.215v3.143a1.5 1.5 0 0 0 1.5 1.5H14V9H8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5.732A2 2 0 0 1 12 15H4a2 2 0 0 1-2-2Zm11.644-8.357-3.427-3.357-.002-.002v2.859a.5.5 0 0 0 .5.5h2.929ZM9.22 10.144V13h1.58v-.476H9.732v-.732h.996v-.476h-.996v-.696H10.8v-.476H9.22Zm-1.388 2.84a.222.222 0 0 0 .164.064.236.236 0 0 0 .168-.064c.045-.045.068-.113.068-.204 0-.093-.023-.16-.068-.2a.236.236 0 0 0-.168-.06.222.222 0 0 0-.164.064c-.043.04-.064.105-.064.196 0 .09.02.159.064.204ZM11.08 13v-2.856h.772l.124 1.604h.032l.128-1.604h.784V13h-.476v-.756c0-.09 0-.19.004-.3l.016-.344.024-.344.02-.308.02-.236a2.01 2.01 0 0 0 .008-.124h-.028l-.256 1.696h-.52l-.248-1.696h-.028c.002.019.005.06.008.124l.016.236a21.854 21.854 0 0 1 .06 1.004c.005.115.008.221.008.32V13h-.468Zm2.18-2.856V13h1.54v-.464h-1.028v-2.392h-.512Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FileTypeEML_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FileTypeEML;
exports["default"] = _default;